export default {
  findYourBill: {
    policyNumber: {
      req: 'Please enter your 10 character policy number.',
      minLength: 'Please enter your 10 character policy number.'
    },
    zipCode: {
      req: 'Please enter the 5 digit property zip code.',
      minLength: 'Please enter the 5 digit property zip code.'
    }
  },
  paymentInformation: {
    otherAmount: {
      req: 'Please enter this info.',
      valid: 'Please enter an amount greater than zero.'
    },
    cardFields: {
      nameOnCard: {
        req: 'Please enter this info.'
      },
      cardNumber: {
        req: 'Please enter this info.',
        valid: 'Please enter a valid credit card number.',
        other: 'Please enter a valid credit card.'
      },
      expirationDate: {
        req: 'Please enter this info.',
        valid: 'Please enter a valid expiration date.'
      },
      cvv: {
        req: 'Please enter this info.',
        valid: 'Please enter a valid CVV.'
      }
    },
    eCheck: {
      bankAccHolderName: {
        req: 'Please enter this info.'
      },
      bankName: {
        req: 'Please enter this info.'
      },
      bankRoutingNumber: {
        req: 'Please enter this info.',
        valid: 'Please enter a valid 9-digit routing number.'
      },
      bankAccNumber: {
        req: 'Please enter this info.',
        valid: 'Please enter a valid account number.'
      }
    },
    billingInformation: {
      firstName: {
        req: 'Please enter this info.'
      },
      lastName: {
        req: 'Please enter this info.'
      },
      address: {
        req: 'Please enter this info.'
      },
      city: {
        req: 'Please enter this info.'
      },
      state: {
        req: 'Please enter this info.'
      },
      zipCode: {
        req: 'Please enter this info.',
        valid: 'Please enter the 5 digit property zip code.'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/en/validation-messages.js